import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EmailsService } from '../../api/services/emails.service';
import { TextMessageTemplatesService } from '../../api/services/text-message-templates.service';
import { EmailTemplate } from '../../api/models/email-template';
import { TextMessageTemplate } from '../../api/models/text-message-template';

@Component({
  selector: 'app-templates-list-page',
  templateUrl: './templates-list-page.component.html',
  styleUrls: ['./templates-list-page.component.scss']
})
export class TemplatesListPageComponent implements OnInit, OnDestroy {

  public emailTemplates: EmailTemplate[] = [];
  public smsTemplates: TextMessageTemplate[] = [];

  private ngDestroy$ = new Subject<void>();

  constructor(
    private emailsService: EmailsService,
    private textMessageTemplatesService: TextMessageTemplatesService
  ) {}

  public ngOnInit(): void {
    this.loadEmailTemplates();
    this.loadSmsTemplates();
  }

  public ngOnDestroy(): void {
    this.ngDestroy$.next();
    this.ngDestroy$.complete();
  }

  private loadEmailTemplates(): void {
    this.emailsService.listEmailTemplates()
      .pipe(takeUntil(this.ngDestroy$))
      .subscribe((templates) => {
        this.emailTemplates = templates;
      });
  }

  private loadSmsTemplates(): void {
    this.textMessageTemplatesService.listTextMessageTemplates()
      .pipe(takeUntil(this.ngDestroy$))
      .subscribe((templates) => {
        this.smsTemplates = templates;
      });
  }
}
